"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setConfig = setConfig;
var runtimeConfig = void 0;

exports.default = function () {
  return runtimeConfig;
};

function setConfig(configValue) {
  runtimeConfig = configValue;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/next/dist/lib/runtime-config.js
// module id = 691
// module chunks = 68